<script>
export default {
  name: "DataProvider",
  props: {
    as: {
      type: String,
      required: false,
      default: null
    },
    source: {
      type: [Function, Object],
      required: true
    }
  },
  computed: {
    data() {
      if (typeof this.source === "object") {
        return this.source;
      }

      return this.source();
    }
  },
  render() {
    const scopedDefault = this.$scopedSlots.default;
    const children = scopedDefault
      ? scopedDefault({ data: this.data })
      : this.$slots.default || [];

    if (!this.as) {
      return children;
    }

    return this.$createElement(
      this.as,
      {
        props: {
          data: this.data
        }
      },
      children
    );
  }
};
</script>
